export const ADD_PEOPLE_LOAD_START_MARK_KEY = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
export const ADD_PEOPLE_LOAD_END_MARK_KEY = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
export const ADD_PEOPLE_READY_MARK_KEY = 'ADD_PEOPLE_READY_MARK_KEY';
